import React, { useState } from "react";
import { createStore, StateMachineProvider } from "little-state-machine";

import AttributesValueStep from "../pages/Directories/AttributesValueStep";
import PermissionsStep from "../pages/Directories/PermissionsStep";
import GeneralInfoStep from "../pages/Directories/GeneralInfoStep";
import GroupObjectUploadStepForm from "../pages/Directories/GroupObjectUploadStepForm";

createStore({ data: {} });
window.sessionStorage.clear();

const GroupObjectStepForm = ({ id, formType, fileServer }) => {
  const [step, setStep] = useState(1);
  const [itemId, setItemId] = useState(id);
  const [stepLength, setStepLength] = useState(4);

  const nextStep = responseId => {
    setStep(step + 1);
    setItemId(responseId);
  };

  const previousStep = responseId => {
    setStep(step - 1);
    setItemId(responseId);
  };

  switch (step) {
    case 1:
      return (
        <GeneralInfoStep
          id={itemId}
          formType={formType}
          nextStepChange={nextStep}
          stepLength={stepLength}
        />
      );
    case 2:
      return (
        <GroupObjectUploadStepForm
          id={itemId}
          previousStepChange={previousStep}
          nextStepChange={nextStep}
          fileServer={fileServer}
          stepLength={stepLength}
        />
      );
    case 3:
      return (
        <StateMachineProvider>
          <AttributesValueStep
            id={itemId}
            formType={formType}
            previousStepChange={previousStep}
            nextStepChange={nextStep}
            stepLength={stepLength}
          />
        </StateMachineProvider>
      );
    case 4:
      return (
        <PermissionsStep
          id={itemId}
          formType={formType}
          previousStepChange={previousStep}
          stepLength={stepLength}
        />
      );
    default:
      return null;
  }
};

export default GroupObjectStepForm;
